(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-bottega"] && !Shopify.designMode) return;
  try {
    
$('.page-navigation-menu__navs .active').click(function(){return false;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contactsection"] && !Shopify.designMode) return;
  try {
    
$('.page-navigation-menu__navs .active').click(function(){return false;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["intro-our-story"] && !Shopify.designMode) return;
  try {
    
$('.page-navigation-menu__navs .active').click(function(){return false;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-chef-alimentari"] && !Shopify.designMode) return;
  try {
    
$('.page-navigation-menu__navs .active').click(function(){return false;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-chef-bottega"] && !Shopify.designMode) return;
  try {
    
$('.page-navigation-menu__navs .active').click(function(){return false;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-vita"] && !Shopify.designMode) return;
  try {
    
$('.page-navigation-menu__navs .active').click(function(){return false;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-nav-menu-alimentari"] && !Shopify.designMode) return;
  try {
    
$('.page-navigation-menu__navs .active').click(function(){return false;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-nav-menu-bottega"] && !Shopify.designMode) return;
  try {
    
$('.page-navigation-menu__navs .active').click(function(){return false;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-nav-menu-ilbuco-almare"] && !Shopify.designMode) return;
  try {
    
$('.page-navigation-menu__navs .active').click(function(){return false;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-nav-menu"] && !Shopify.designMode) return;
  try {
    
$('.page-navigation-menu__navs .active').click(function(){return false;});

  } catch(e) { console.error(e); }
})();
})();
